import { VXETable } from 'vxe-table'

VXETable.renderer.add('tseNumInput', {
    // 项显示模板
    renderItem(h, renderOpts, params) {
        const { data, property } = params
        const props = renderOpts.props || {}
        return [
            <tse-num-input v-model={data[property]} {...{ props }}></tse-num-input>
        ]
    }
})

VXETable.renderer.add('tseDateInput', {
    // 项显示模板
    renderItem(h, renderOpts, params) {
        const { data, property } = params
        const props = renderOpts.props || {}
        return [
            <tse-date-input v-model={data[property]} {...{ props }}></tse-date-input>
        ]
    }
})

VXETable.renderer.add('tsePhoneInput', {
    // 项显示模板
    renderItem(h, renderOpts, params) {
        const { data, property } = params
        const props = renderOpts.props || {}
        return [
            <tse-phone-input v-model={data[property]} {...{ props }}></tse-phone-input>
        ]
    }
})

VXETable.renderer.add('tsePatternInput', {
    // 项显示模板
    renderItem(h, renderOpts, params) {
        const { data, property } = params
        const props = renderOpts.props || {}
        return [
            <tse-pattern-input v-model={data[property]} {...{ props }}></tse-pattern-input>
        ]
    }
})

VXETable.renderer.add('tseCodeInput', {
    // 项显示模板
    renderItem(h, renderOpts, params) {
        const { data, property } = params
        const props = renderOpts.props || {}
        return [
            <tse-code-input v-model={data[property]} {...{ props }}></tse-code-input>
        ]
    }
})

VXETable.renderer.add('tseFormNavigator', {
    // 项显示模板
    renderItem(h, renderOpts, params) {
        const { data, property } = params
        const props = renderOpts.props || {}
        return [
            <tse-form-navigator v-model={data[property]} {...{ props }}></tse-form-navigator>
        ]
    }
})